module.exports = __webpack_public_path__ + "img/max-file-deny--xml.1089fa99.svg";